<template>
    <div>
        <home-map :city-data="cityData" :show-type="showType" @showLayoutModalLogin="showLayoutModalLogin"></home-map>
    </div>
</template>

<script>
import cityData from './map-data/get-city-value.js'
import homeMap from './components/ChinaMap.vue'

export default {
  name: 'home',
  components: {
    homeMap
  },
  data () {
    return {
      showType: 0,
      cityData: cityData[0]
    }
  },
  methods: {
    changeMedia (type) {
      this.showType = type
      this.cityData = cityData[type]
    },
    showLayoutModalLogin () {
      this.$emit('showModalLogin')
    }
  }
}
</script>
